export default __webpack_public_path__ + "static/media/hero-bg.b6848381.png";